import React, { Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalComponent from '@components/common/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import Loading from '@components/common/Loading';
import TicketCreateContent from './TicketCreateContent';
import { ITicketTag } from '@models/SupportTicket';
import SupportTicketApi from 'apis/api/SupportTicket';
import { message } from 'antd';
import { updateForceReloadTicketData } from '@slice/select.slice';

interface ITicketCreateModal {
  isOpen: boolean;
  callBackClose: () => any;
}

export default function TicketCreateModal(props: ITicketCreateModal) {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const handleCancel = () => {
    props.callBackClose();
  };

  const callBackCloseModal = () => {
    props.callBackClose();
  };

  const callBackCreated = () => {
    console.log('callBackCreated');
    dispatch(updateForceReloadTicketData(new Date().getTime()));
    // gửi lệnh yêu cầu nơi hiển thị sanh sách phiếu kêu reload lại list
    // hiện tại modal đang ở trong Layout.tsx ko liên quan đến nơi chứa danh sách phiếu thực sự
    // quá phiền đó là lý do tanstack query mạnh là vậy.. có thể yc call lại data xuyên biên giới ko tốn 1 var site eff nào !!!
  };

  const [tags, setTags] = useState<ITicketTag[]>([]);

  const fetchTags = useCallback(async () => {
    try {
      const res = await SupportTicketApi.GetStuctureTag();
      if (!res?.data?.error) setTags(res.data.data?.tags || []);
      else message.error(res?.data?.message || 'Không tải được danh sách nhóm hỗ trợ!');
    } catch (error) {
      message.error('Xảy ra lỗi khi tải danh sách nhóm hỗ trợ!');
    } finally {
      //
    }
  }, []);

  useEffect(() => {
    fetchTags();
  }, []);

  const categoriesData = useMemo(
    () =>
      tags.flatMap(tag =>
        (tag.categories || []).map(cat => ({
          ...cat,
          tagName: tag.name,
          tagId: tag.id,
          statusText: cat.isDisable ? 'Đã tắt' : 'Đang hoạt động'
        }))
      ),
    [tags]
  );

  // console.log('tags:', tags, 'categoriesData:', categoriesData);

  return (
    <>
      <ModalComponent
        modalTitle={'Tạo phiếu hỗ trợ'}
        modalType="update"
        modalSize="fit"
        visible={props.isOpen}
        hiddenFooter={true}
        onCancel={handleCancel}
      >
        <Suspense fallback={<Loading />}>
          <TicketCreateContent
            tags={tags}
            categories={categoriesData} // nơi nào có data truyền vô đây dùm
            onClose={callBackCloseModal}
            onCreated={callBackCreated}
          />
        </Suspense>
      </ModalComponent>
    </>
  );
}
